module.exports = __webpack_public_path__ + "static/media/Products2.36a11508.png";